module.exports = "//static.hsappstatic.net/ecosystem-marketplace-solutions-base/static-1.13507/img/partner-award-badge.svg"